import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Heading, Label, colors, media } from '../ui-components';

const propTypes = {
  className: PropTypes.string,
  percentage: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  isCentered: PropTypes.bool,
};

/**
 * Renders a Metric Component
 * 
 * @component Metric
 *  
 * @param {*} props
 * 
 * @prop {string} className
 * @prop {number} percentage
 * @prop {string} title
 * @prop {boolean} isCentered
 * 
 * @return {JSX}
 */
const Metric = props => {
  const { className, percentage, title, isCentered = false } = props;

  return (
    <MetricWrapper className={className} isCentered={isCentered}>
      <PercentageHeading level={6}>{`${percentage}%`}</PercentageHeading>
      <Label>{title}</Label>
    </MetricWrapper>
  );
};

const MetricWrapper = styled.div`
  text-align: center;
  width: 100%;
  margin: ${({ isCentered }) => isCentered ? '0 auto' : 'unset' };
  padding: 10px 0;

  @media (min-width: ${media.mediumBottom}) {
    max-width: 200px;
  }
`;

const PercentageHeading = styled(Heading)`
  color: ${colors.crederaRed};
  font-size: 40px;
  line-height: 56px;

  @media (min-width: ${media.mediumBottom}) {
    font-size: 64px;
    line-height: 80px;
  }
`;

Metric.propTypes = propTypes;

export default Metric;
